import 'react-multi-carousel/lib/styles.css';
import * as React from 'react';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import OfficeAction from '../components/officeAction/OfficeAction';
import ProductChat from '../components/product/ProductChat';
import ProductHeader from "components/product/ProductHeader";
import ProgressBar from 'components/atomic/ProgressBar';
import { checkEmail } from '../helpers/emailChecker';
import { usePrevious } from '../hooks';
import { NextSeo } from 'next-seo';
import { config } from '_config';
import { xVerifyService } from 'services';

const { apiUrl } = config;

const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"];

export default function OfficeActionResponse() {
  const router = useRouter();
  const rightSide = useRef();
  const [trademarkRushProcessing, setTrademarkRushProcessing] = useState({
    code: 'TRADEMARK_Trademark_Rush_Processing',
  });

  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );
    let url = apiUrl + '/category/TRADEMARKS/products/prices';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices';

    axios
      .get(url, {
        params: { onlyForSale: false },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200) {
          response.data
            .filter((product) =>
              product.code.code.includes('TRADEMARK_Trademark_Rush_Processing')
            )
            .forEach((rushTrademark) => {
              trademarkRushProcessing.price = rushTrademark.price;
              trademarkRushProcessing.customerName =
                rushTrademark.code.customerName;
              setTrademarkRushProcessing(trademarkRushProcessing);
            });
          const product = JSON.parse(localStorage.getItem('product'));
          const historyPath = localStorage.getItem('path');
          if (
            historyPath &&
            historyPath === 'office-action-response' &&
            product
          ) {
            window.scrollTo(0, 0);
            setState({ ...product });
          }
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              params: { onlyForSale: false },
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200) {
                response.data
                  .filter((product) =>
                    product.code.code.includes(
                      'TRADEMARK_Trademark_Rush_Processing'
                    )
                  )
                  .forEach((rushTrademark) => {
                    trademarkRushProcessing.price = rushTrademark.price;
                    trademarkRushProcessing.customerName =
                      rushTrademark.code.customerName;
                    setTrademarkRushProcessing(trademarkRushProcessing);
                  });
                const product = JSON.parse(localStorage.getItem('product'));
                const historyPath = localStorage.getItem('path');
                if (
                  historyPath &&
                  historyPath === 'office-action-response' &&
                  product
                ) {
                  window.scrollTo(0, 0);
                  setState({ ...product });
                }
              }
            });
        }
      });
  }, []);

  const [state, setState] = React.useState({
    code: 'TRADEMARK_Trademark_Office_Action_Response',
    serialProvided: 'true',
    serialNumber: null,
    markDesc: null,
    markOwnerFirstName: null,
    markOwnerLastName: null,
    markOwnerEmail: null,
    markOwnerPhone: null,
    changeAddress: 'false',
    newaddress: null,
    newcity: null,
    newstate: null,
    newzip: null,
    newDrawing: 'false',
    changeMarkOwner: 'false',
    changeMarkOwnerFirstName: null,
    changeMarkOwnerLastName: null,
    changeMarkOwnerDesc: null,
    needsSpecimen: 'no',
    goodsOrService: 'BOTH',
    trademarkRushType: 'TRADEMARK_Trademark_Rush_Processing',
    rushProcessing: true,
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    verifying: false,
    verificationResult: {},
    step: 0,
  });

  const prevState = usePrevious(state);

  const verifyEmail = useCallback(() => {
    if (!state.verificationResult?.email && checkEmail(state.email)) {
      setState((prevState) => ({ ...prevState, verifying: true }));

      xVerifyService.verifyEmail(state.email).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: {
              ...prevState.verificationResult,
              email: result,
            },
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const verifyMarkOwnerEmail = useCallback(() => {
    if (
      !state.verificationResult?.markOwnerEmail &&
      checkEmail(state.markOwnerEmail)
    ) {
      setState((prevState) => ({ ...prevState, verifying: true }));

      xVerifyService.verifyEmail(state.markOwnerEmail).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: {
              ...prevState.verificationResult,
              markOwnerEmail: result,
            },
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const handleBlur = useCallback(
    (e) => {
      const { type } = e.target;
      if (type === 'email' && state.step === 3) {
        verifyEmail();
      }
      if (type === 'email' && state.step === 0) {
        verifyMarkOwnerEmail();
      }
    },
    [state, verifyEmail, verifyMarkOwnerEmail]
  );

  function handleChange(e) {
    if (e.target.name) {
      if (e.target.name === 'rushProcessing') {
        setState({ ...state, [e.target.name]: e.target.checked });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.name]: e.target.checked })
        );
      } else {
        if (e.target.type === 'email') {
          setState({
            ...state,
            [e.target.name]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.name]: null,
            },
          });
          localStorage.setItem(
            'product',
            JSON.stringify({
              ...state,
              [e.target.name]: e.target.value,
              verificationResult: {
                ...state.verificationResult,
                [e.target.name]: null,
              },
            })
          );
        } else {
          setState({ ...state, [e.target.name]: e.target.value });
          localStorage.setItem(
            'product',
            JSON.stringify({ ...state, [e.target.name]: e.target.value })
          );
        }
      }
    } else {
      if (e.target.type === 'email') {
        setState({
          ...state,
          [e.target.id]: e.target.value,
          verificationResult: {
            ...state.verificationResult,
            [e.target.id]: null,
          },
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            [e.target.id]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.id]: null,
            },
          })
        );
      } else {
        setState({ ...state, [e.target.id]: e.target.value });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.id]: e.target.value })
        );
      }
    }
    localStorage.setItem('path', 'office-action-response');
  }

  function handleStep(value) {
    setState({ ...state, step: value });
    localStorage.setItem('product', JSON.stringify({ ...state, step: value }));
    localStorage.setItem('path', 'office-action-response');
    router.push('/office-action-response?step=' + value, undefined, {
      shallow: true,
    });
  }

  useEffect(() => {
    if (router.query.step)
      setState({ ...state, step: parseInt(router.query.step, 10) });
  }, [router.query.step]);

  useEffect(() => {
    if (prevState?.email === null) {
      verifyEmail();
    }
    if (prevState?.markOwnerEmail === null) {
      verifyMarkOwnerEmail();
    }
  }, [prevState, state, verifyEmail, verifyMarkOwnerEmail]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      rightSide.current?.scrollIntoView();
    });

    return () => {
      clearTimeout(timeout);
    };
  }, [rightSide.current]);

  useEffect(() => {
    let timeout;

    function handleRouteChangeComplete() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      });
    }

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      clearTimeout(timeout);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);

  return (
    <div className="reg" ref={config.skin === 'v2-basic' ? rightSide : null}>
      <NextSeo title="Office Action Response" />
      {config.skin === 'v2-basic' && (
        <div className="filing-banner-outer-container">
          <div className="filing-banner-inner-container">
            <ProductHeader header="Office Action Filing" />
            <ProgressBar value={state.step + 1} maxValue={steps.length} />
          </div>
        </div>
      )}
      <div className="side-wrapper">
        <div className="left-side">
          <div className="banner">
            <div className="summary">
              <h3>Office Action Summary</h3>
              <div className="step-box">
                {state.serialProvided === 'true' ? (
                  <>
                    <h5>SERIAL NUMBER</h5>
                    <p>{state.serialNumber}</p>
                  </>
                ) : (
                  <>
                    <h5>OWNER OF MARK {state.markDesc}</h5>
                    <p>
                      {state.markOwnerFirstName ? state.markOwnerFirstName : ''}{' '}
                      {state.markOwnerLastName ? state.markOwnerLastName : ''}
                    </p>
                    <p>
                      {state.markOwnerPhone ? state.markOwnerPhone : ''}{' '}
                      {state.markOwnerEmail ? state.markOwnerEmail : ''}
                    </p>
                  </>
                )}
              </div>
              {state.step > 0 ? (
                <div className="step-box">
                  <h5>CHANGES</h5>
                  {state.changeAddress === 'true' ? (
                    <>
                      <p>
                        {state.newaddress ? state.newaddress : ''}{' '}
                        {state.newcity ? state.newaddress : ''}{' '}
                        {state.newstate ? state.newstate : ''}{' '}
                        {state.newzip ? state.newzip : ''}
                      </p>
                    </>
                  ) : null}
                  {state.newDrawing === 'true' ? (
                    <>
                      <p>New drawing</p>
                    </>
                  ) : null}
                  {state.changeMarkOwner === 'true' ? (
                    <>
                      <p>
                        {state.changeMarkOwnerFirstName}{' '}
                        {state.changeMarkOwnerLastName}
                      </p>
                    </>
                  ) : null}
                </div>
              ) : null}
              {state.step > 1 ? (
                <div className="step-box">
                  <h5>NEW SPECIMEN</h5>
                  <p>
                    {state.needsSpecimen === 'know'
                      ? "I don't know"
                      : state.needsSpecimen}
                  </p>
                  {state.needsSpecimen === 'yes' ? (
                    <p>Class type: {state.goodsOrService}</p>
                  ) : null}
                </div>
              ) : (
                ''
              )}
              {state.step > 2 ? (
                <div className="step-box">
                  <h5>YOUR ACCOUNT</h5>
                  <p>
                    {state.firstName ? state.firstName : ''}{' '}
                    {state.lastName ? state.lastName : ''}
                  </p>
                  <p>
                    {state.phone ? state.phone : ''}{' '}
                    {state.email ? state.email : ''}
                  </p>
                </div>
              ) : (
                ''
              )}
              {state.step > 3 && state.rushProcessing ? (
                <div className="step-box">
                  <h5>THE PROCESSING SPEED</h5>
                  <p>
                    Rush Priority Processing. Next day processing when you need
                    mark filed quickly.
                  </p>
                </div>
              ) : null}
              <ProductChat />
            </div>
          </div>
        </div>
        <div className="right-side" id="rightSide" ref={config.skin === 'v2-basic' ? null : rightSide}>
          <div className="form">
            <OfficeAction
              state={state}
              onChange={handleChange}
              onBlur={handleBlur}
              onStep={handleStep}
              trademarkRushProcessing={trademarkRushProcessing}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
